import React from 'react';
import styled from '@emotion/styled';
import MUICheckbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes, { InferProps } from 'prop-types';
import Favorite from '../Icons/Favorite';
import FavoriteOutline from '../Icons/FavoriteOutline';

const StyledFormControlLabel = styled(FormControlLabel)`
  position: relative;
  bottom: 2px;
  .MuiFormControlLabel-label {
    color: ${({ theme }) => theme.colors.blackMedium};
    font-family: ${({ theme }) => theme.fonts.primary};
    transform: none;
    letter-spacing: unset;
    margin: 2px 0 0px;
  }
  .MuiButtonBase-root {
    padding: 3px;
  }
`;

const favoriteCheckboxPropertyTypes = {
  checked: PropTypes.bool,
  checkedColor: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  uncheckedColor: PropTypes.string,
  onClick: PropTypes.func,
};

type FavoriteCheckboxProperties = Omit<InferProps<
  typeof favoriteCheckboxPropertyTypes
>, 'onClick'> & {
  checked?: boolean;
  uncheckedColor?: string;
  checkedColor?: string;
  label?: string;
  name?: string;
  onChange?: () => void;
};

const FavoriteCheckbox = ({
  checked = false,
  name,
  onChange,
  label,
  checkedColor,
  uncheckedColor,
  ...properties
}: FavoriteCheckboxProperties) => (
  <StyledFormControlLabel
    control={(
      <MUICheckbox
        inputProps={{ 'aria-label': label }}
        icon={(
          <FavoriteOutline
            fillColor={uncheckedColor}
          />
        )}
        checkedIcon={(
          <Favorite
            fillColor={checkedColor}
            title="Favorite"
          />
        )}
        name={name}
        checked={checked}
        onChange={onChange}
        {...properties}
      />
    )}
    label={name}
  />
);

FavoriteCheckbox.propTypes = favoriteCheckboxPropertyTypes;

export default FavoriteCheckbox;
